import type { SVGProps } from "react";
const SuiExpandIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#expand_svg__a)">
      <path d="M11.674.038c.69-.18 1.498.305 1.69 1.2.283 6.934.043 13.962.122 20.93-.128 2.08-2.27 2.537-2.852.602-.282-6.934-.042-13.962-.122-20.93.072-.855.481-1.623 1.163-1.802M19.93 10.11c.024-.474-.188-2.095.498-1.842L24 11.947l-.2.504-3.37 3.288c-.687.252-.475-1.368-.5-1.843h-4.312c-.187 0-.664-.575-.718-.852-.066-.33-.066-1.751 0-2.083.054-.277.531-.852.718-.852h4.313M4.07 13.898c-.025.473.187 2.095-.5 1.842L0 12.06l.2-.504 3.37-3.288c.687-.253.475 1.367.5 1.842h4.312c.187 0 .664.576.718.852.066.33.066 1.752 0 2.084-.054.276-.531.852-.718.852z" />
    </g>
    <defs>
      <clipPath id="expand_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SuiExpandIcon;
